import { IFontWeight } from '../types';

export const fontWeight: IFontWeight = {
  headings: 'bold',
  primary: 'normal',
  secondary: 'normal',
  tertiary: 'normal',
  link: 'normal',
  button: 'normal',
};
